/**
 * Composable to read location data set by the validate-location middleware.
 * Use on pages that run validate-location so they can act on the validated
 * location (continent, country, city, region, area, district) and root context
 * (property type or internal root like events).
 *
 * Backed by useState() so the value is reactive and stays current across both
 * the initial SSR render and subsequent SPA navigations.
 *
 * @returns {import('vue').Ref<{ rootKind: string, root: object, level: string, location: object } | null>}
 */

export function useLocationData() {
  return useState('locationData', () => null);
}
